// eslint-disable-next-line no-unused-vars
import React from 'react'; 
import { withStyles } from '@material-ui/core/styles';

import MediaQuery from "react-responsive";

import { withTranslation } from 'react-i18next';

const styles = () => ({
    root: {
	    backgroundColor: "#EFEFEF",
	    overflow: "hidden",
	},
	footer: {
	    padding: "1em 0",
	    minHeight: 120,
	    textAlign: "center",
	    fontFamily: 'AIGFutura_Bold',
	    fontSize: "1.5em",
	    color: "#33729B",
	},
	footerTable: {
		margin: "0 auto",
	},
	footerTitle: {
	    marginBottom: "0.4em",
	    fontSize: "140%",
	    fontWeight: "900",
	},
	footerValues: {
		textAlign: "left",
		paddingLeft: "0.5em",
	},
	emailLabel: {
		fontSize: ".8em",
		color: "#009ca6",
	},
	emailLabel2: {
		fontSize: "1.2em",
	    color: "#009ca6", 
	},
	emailValue: {
		fontSize: ".6em",
		color: "black",
	},
	emailValue2: {
		fontSize: "0.8em",
		color: "black",
	},
	hotlineLabel: {
		fontSize: "0.6em",
		color: "black",
	},
	hotlineLabel2: {
		fontSize: "0.8em",
		color: "black",
	},
	hotlineValue: {
		fontSize: ".8em",
		color: "#b5006b",
	},
	hotlineValue2: {
		fontSize: "1.2em",
		color: "#b5006b",
	},
	office_hrValue: {
		fontSize: "0.6em",
		color: "black",
	},
	office_hrValue2: {
		fontSize: "0.6em",
        color: "black",
        paddingTop: 8,
        display: "block",
        lineHeight: "16px",
        whiteSpace: "pre",
	},
	faqValue: {
		fontSize: ".8em",
		color: "#3388cc",
	},
	faqValue2: {
		fontSize: "1.2em",
		color: "#3388cc",
	},
	
	footerLinksContainer: {
        display: "table",
        margin: "auto",
	},
	footerLinkItem: {
        display: "inline-block",
        lineHeight: "1.1em",
        verticalAlign: "middle",
        padding: "0.5em",
        textAlign: "left",
	},
	footerSeparator: {
		display: "inline-block",
	    lineHeight: "1.25em",
	    height: "5em",
	    padding: 0,
	    margin: "0 1em",
	    width: 2,
	    backgroundColor: "#ccc",
	    verticalAlign: "middle",
	},
	
	motisDownloadLinksContainer: {
		width: "100%",
		backgroundColor: "#D2D2D2", 
	},
	motisDownloadLinks: {
		width: "fit-content",
		margin: "0 auto",
		fontWeight: "normal",
		lineHeight: "2em",
		minHeight: 35,
		padding: "5px 0",
		textAlign: "left",
		fontFamily: 'AIGFutura_Book',
		fontSize: "1em",
		backgroundColor: "#D2D2D2", 
		color: "#76777b",
		textShadow: "none",
	},
	downloadLink: {
	    textDecoration: "underline",
	    color: "grey",
	    fontSize: "1em",
	    fontWeight: "normal",
//	 a.downloadLink:visited, a.downloadLink:active {
	},
	
	
	remarkContainer: {
		minHeight: 25,
		padding: "5px 0 5px 0",
		textAlign: "right",
		fontFamily: 'AIGFutura_Book', 
		fontSize: 12,
		backgroundColor: "#333333",
		color: "#BBBBBB",
	},
	remarkDetail: {
		textShadow: "none",
	},
	
	footerStatmentContainer: {
		minHeight: 25,
		padding: "5px 0 5px 0",
		textAlign: "right",
		fontFamily: 'AIGFutura_Book', 
		fontSize: 12,
		backgroundColor: "#191919", 
		color: "#BBBBBB",
	},
	footerStatmentDetail: {
		textShadow: "none",
	},
	
	footerDLLabel: {
		margin: "10px 20px 10px 20px",
	},
});

interface PassInProperty{
	classes: object;
	t: any ;
	hotline: string;
	dl_links: string;
	withFAQ: boolean;
}	

@withStyles(styles)
@withTranslation()
class PageFooter extends React.Component<PassInProperty> {
		
	render(){
		const {classes, t, hotline, dl_links, withFAQ} = this.props;
		const  email_addr = t("emailus_text");
		const faq_label = t("faq_lbl");
	
		const getDownloadLinks = [];
		
		if(dl_links && dl_links.length) {
			for (let i = 0; i < dl_links.length; i++) {
				getDownloadLinks[i] = (
					<div key={i}>
						<i className={`icon-motis-download`} aria-hidden="true"></i>
						<span className={classes.footerDLLabel}>
							<a className={classes.downloadLink} href={dl_link.url} target="_blank">
								{dl_link.title}
							</a>
						</span>
						
						<MediaQuery query="(max-width: 47.9375em)">
							<br />
						</MediaQuery>
					</div>
				);
			}
			
		}

		return (
			<div className={classes.root}>

				<MediaQuery query="(max-width:992px)">
					<style>{`
						.footer {
							font-size:1.2em;
						}
					`}</style>
				</MediaQuery>
				
				<div className={`row between-xs middle-xs footer ${classes.footer}`}>
					<div className={`col-xs`}>
						<div className={`footerTitle`} >
							{t("got_question_lbl")}
						</div>
						<MediaQuery minDeviceWidth={768}>
							<div>
								<div className={`row center-sm`}>
									{email_addr && (
										<div>
											<div className={classes.footerLinksContainer}>
												<div className={classes.footerLinkItem}>
													<i className={`ui-icon-email`}></i>
												</div>
												<div className={classes.footerLinkItem}>
											<span className={classes.emailLabel2}>
												{t("emailus_lbl")}
											</span>
													<br />
													<a className={classes.emailValue2} href={t("emailus_link")}>
														{email_addr}
													</a>
												</div>
											</div>
										</div>
									)}
									{email_addr && (
										<div className={classes.footerSeparator}></div>
									)}
									<div>
										<div className={classes.footerLinksContainer}>
											<div className={classes.footerLinkItem}>
												<i className={`ui-icon-contact`}></i>
											</div>
											<div className={classes.footerLinkItem}>
											<span className={classes.hotlineLabel2} >
												{t("hotline_lbl")}
											</span>
												<br />
												<a className={classes.hotlineValue2} href={"tel:+852"+hotline}>
													{hotline}
												</a>
												<br />
												<span className={classes.office_hrValue2}>
												{t("office_hr")}
											</span>
											</div>
										</div>
									</div>

									{withFAQ &&
										<div className={classes.footerSeparator}></div>
									}

									{withFAQ &&
									<div>
										<div className={classes.footerLinksContainer}>
											<div className={classes.footerLinkItem}>
												<i className={`ui-icon-faq`}></i>
											</div>
											<div className={classes.footerLinkItem}>
												<a href={t("faqlink")} target="_blank" className={classes.faqValue2}>
													{faq_label}
												</a>
											</div>
										</div>
									</div>
									}
								</div>
							</div>
						</MediaQuery>
						<MediaQuery maxDeviceWidth={767}>
							<div>
								<table className={classes.footerTable}>
									<tbody>
									{email_addr && (
										<tr>
											<td>
												<i className={`ui-icon-email`}></i>
											</td>
											<td className={classes.footerValues}>
											<span className={classes.emailLabel}>
												{t("emailus_lbl")}
											</span><br />
												<a className={classes.emailValue} href={t("emailus_link")}>
													{email_addr}
												</a>
											</td>
										</tr>
									)}
									<tr>
										<td>
											<i className={`ui-icon-contact`}></i>
										</td>
										<td className={classes.footerValues}>
											<span className={classes.hotlineLabel}>
												{t("hotline_lbl")}
											</span>
											<br />
											<a className={classes.hotlineValue} href={"tel:+852"+hotline}>
												{hotline}
											</a>
											<br />
											<span className={classes.office_hrValue} >
												{t("office_hr")}
											</span>
										</td>
									</tr>

									{withFAQ &&
									<tr>
										<td>
											<i className={`ui-icon-faq`}></i>
										</td>
										<td className={classes.footerValues}>
											<a href={t("faqlink")} target="_blank" className={classes.faqValue}>
												{faq_label}
											</a>
										</td>
									</tr>
									}

									</tbody>
								</table>
							</div>
						</MediaQuery>
					</div>
				</div>
				
				
				
				{dl_links && dl_links.length && (
					<div className={classes.motisDownloadLinksContainer}>
						<MediaQuery query="(max-width: 47.9375em)">
							<div className={`${classes.motisDownloadLinks}`} >
								{getDownloadLinks}
							</div>
						</MediaQuery>
						
						<MediaQuery query="(min-width: 47.9375em)">
							<div className={`row ${classes.motisDownloadLinks}`}>
								{getDownloadLinks}
							</div>
						</MediaQuery>
					</div>
				)}
				
				
				
				
				<div className={`row between-sm middle-sm ${classes.remarkContainer}`}>
					<div className={`col-xs-1 col-lg-2`}></div>
					<div className={`col-xs-10 col-lg-8 ${classes.remarkDetail}`}>
						<i className={`ui-icon-paydollar`}></i>
						{t("trusted_gateway_lbl")}
					</div>
					<div className={`col-xs-1 col-lg-2`}></div>
				</div>
				
				
				
				
				<div className={`row between-sm middle-sm ${classes.footerStatmentContainer}`}>
					<div className={`col-xs-1 col-lg-2`}></div>
					<div className={`col-xs-10 col-lg-8 ${classes.footerStatmentDetail}`}>
						<a target="_blank" href={t("footer_term_of_use_url")}>
								{t("footer_term_of_use_lbl")}
						</a>
						&nbsp;|&nbsp; 
						<a target="_blank" href={t("footer_privacy_url")}>
							{t("footer_privacy_lbl")}
						</a>
						<br />
						{t("copyright_lbl", { year: (new Date().getFullYear())})}
					</div>
					<div className={`col-xs-1 col-lg-2`}></div>
				</div>
				
			</div>
		);
	}
}

export default PageFooter;